import { html, nothing, render } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { translate } from "@escapio/shared/l10n/translate";
import { stateful } from "@escapio/shared/components/element-builder";
import { hasSignedUp } from "@escapio/portal/components/newsletter/popupTracker";
import "./Form";
import unsaferHTML from "@escapio/shared/unsaferHTML";

const RESTRICT_SIGNED_UP = "signed-up";
const RESTRICT_NOT_SIGNED_UP = "not-signed-up";

customElements.define(
	"esc-newsletter-banner",
	stateful(
		class extends HTMLElement {
			static getInitialState() {
				return {
					isSuccess: false,
					isError: false,
					hasSignedUp: hasSignedUp(),
				};
			}

			render() {
				if (!this.showBanner()) {
					this.style.display = "none";
				}
				const infoLink = `<a
					class="text-underline"
					href="/newsletter"
				>${translate("newsletter_banner_tos_info_link_label")}</a>`;
				const template = this.showBanner()
					? html`<esc-impression-interaction-tracker
							class="newsletter-banner__box ${classMap({
								"newsletter-banner__box--message":
									this.isError || this.isSuccess,
							})}"
							content-name="Newsletter Banner"
							content-piece="${this.location}"
							content-target="#"
						>
							<div
								class="${classMap({
									hidden: this.isSuccess || this.isError,
								})}"
							>
								<header class="newsletter-banner__heading">
									<span class="mobile-only">
										${translate("newsletter_banner_heading_mobile")}
									</span>
									<span class="hidden-mobile">
										${translate("newsletter_banner_heading_tablet")}
									</span>
								</header>
								<div class="newsletter-banner__description">
									<span class="mobile-only">
										${translate("newsletter_banner_description_mobile")}
									</span>
									<span class="hidden-mobile">
										${translate("newsletter_banner_description_tablet")}
									</span>
								</div>
							</div>
							<div>
								<esc-newsletter-form
									location="Banner ${this.location}"
									@submitSuccess="${this.onSuccess}"
									@submitError="${this.onError}"
									?inverse-error=${this.hasInverseError}
								></esc-newsletter-form>
								<div
									class="newsletter-banner__tos-info ${classMap({
										hidden: this.isSuccess || this.isError,
									})}"
								>
									<span class="mobile-only">
										${unsaferHTML(
											translate("newsletter_banner_tos_info_mobile", infoLink),
										)}
									</span>
									<span class="hidden-mobile">
										${unsaferHTML(
											translate("newsletter_banner_tos_info_tablet", infoLink),
										)}
									</span>
								</div>
							</div>
						</esc-impression-interaction-tracker>`
					: nothing;
				render(template, this, { host: this });
			}

			onSuccess() {
				this.isSuccess = true;
			}

			onError() {
				this.isError = true;
				this.classList.add("newsletter-banner--error");
			}

			get location() {
				return this.getAttribute("location");
			}

			get restricted() {
				return this.getAttribute("restricted");
			}

			get hasInverseError() {
				return this.hasAttribute("inverse-error");
			}

			showBanner() {
				return (
					(this.restricted != RESTRICT_SIGNED_UP &&
						this.restricted != RESTRICT_NOT_SIGNED_UP) ||
					(this.restricted == RESTRICT_SIGNED_UP && this.hasSignedUp) ||
					(this.restricted == RESTRICT_NOT_SIGNED_UP && !this.hasSignedUp)
				);
			}
		},
	),
);
